import { Box, Typography } from '@mui/material';

import { getThemeColor } from '../../utils/common';
import { FORTA_BLUE, FORTA_WHITE } from '../../utils/colors';
import { Themes } from '../../constants';

import type { ReactNode } from 'react';

interface FBoxContainerProps {
  title?: string;
  info?: string;
  titleVariant?: any;
  children?: ReactNode;
  colorTheme?: Themes;
  sx?: any;
  headerStyle?: any;
  contentStyle?: any;
  dataTestId?: string;
}

function FBoxContainer(props: FBoxContainerProps) {
  const {
    title = '',
    info,
    titleVariant = 'h3',
    children,
    sx,
    headerStyle = {},
    contentStyle = {},
    colorTheme = Themes.Primary,
    dataTestId = '',
  } = props;

  return (
    <Box
      data-testid={dataTestId}
      sx={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        backgroundColor: getThemeColor(colorTheme).light3,
        borderRadius: '10px',
        boxShadow: 'none',
        border: `1px solid ${FORTA_BLUE.light2}`,
        ...sx,
      }}
    >
      {Boolean(title) && (
        <Box
          sx={{
            display: 'flex',
            backgroundColor: getThemeColor(colorTheme).primary,
            borderRadius: '10px',
            boxShadow: `0px 4px 4px ${getThemeColor(colorTheme).light2}`,
            height: 40,
            flexGrow: 1,
            width: 'calc(100% + 4px)',
            marginLeft: '-2px',
            px: 3,
            ...headerStyle,
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography variant={titleVariant} color={FORTA_WHITE}>
            {title}
          </Typography>
          {Boolean(info) && (
            <Typography variant={'body1'} color={FORTA_WHITE}>
              {info}
            </Typography>
          )}
        </Box>
      )}
      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, p: 3, ...contentStyle }}>
        {children}
      </Box>
    </Box>
  );
}

export default FBoxContainer;
